import { render, staticRenderFns } from "./TableAuthorizerReady.vue?vue&type=template&id=23ba2d8e&"
import script from "./TableAuthorizerReady.vue?vue&type=script&lang=ts&"
export * from "./TableAuthorizerReady.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports